import Vue from 'vue'

/**
 * CSV形式で記載されたユーザーの並び順をインポートし適用する
 * @param {Object} csvData インポートするCSV
 * @returns {Array} 整形したデータ
 */
function importCsv (file) {
  // 拡張子が「.csv」ではない場合
  if (!file.name.toUpperCase().match(/\.(CSV)$/i)) {
    Vue.swal({
      icon: 'error',
      title: 'インポート失敗',
      html: `CSV形式のファイルではありません`,
      allowOutsideClick: false
    })
    return
  }
  try {
    return file.text().then((csv) => {
      let importData = []
      // ヘッダーを削除し、改行で配列を分ける
      const body = csv.replace(/\r/g, '').split('\n').slice(2)
      // カンマを削除
      const rows = body.map((row) => { return row.split(/,(?=(?:[^"]*"[^"]*")*[^"]*$)/) })
      // ダブルクォーテーションを削除
      importData = rows.map((row) => {
        return row.map((col) => {
          return col.replace(/^"|"$/g, '').replace(/""/g, '"').trim()
        })
      })
      return importData
    })
  } catch (error) {
    console.error(error)
    Vue.swal({
      icon: 'error',
      title: 'インポート失敗',
      text: `予期せぬエラーが発生しました`,
      allowOutsideClick: false
    })
    return
  }
}

/**
 * 整形したデータをCSVとしてエクスポートする
 * @param {Object} csv エクスポートするCSV
 * @param {Object} type エクスポートするファイルの種別
 */
function exportCsv (csv, type) {
  const bom  = new Uint8Array([0xEF, 0xBB, 0xBF]);
  const blob = new Blob([bom, csv], { type: 'text/csv' })
  const link = document.createElement('a')
  link.href = window.URL.createObjectURL(blob)
  link.download = `${type}-${new Date().getTime()}.csv`
  link.click()
}

/**
 * カンマ、ダブルクォーテーションが含まれている文字列をエスケープする
 * @param {String} formatString カンマが含まれているか判別する文字列
 * @returns {String} 処理された文字列
 */
function formatCsv (formatString) {
  // 文字列に「"」が含まれている場合エスケープする
  if (/"/.test(formatString)) {
    formatString = formatString.replace(/"/g, '""')
  }
  return /,|"/.test(formatString) ? `"${formatString}"` : formatString
}

export default {importCsv, exportCsv, formatCsv}



// WEBPACK FOOTER //
// ./src/utils/csv.js